import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { useState } from 'react'

const ShareIcon  = () =>  {
    const [show, setShow] = useState(false);
    const [mailto, setMailTo] = useState('');

    const shareTo = (param, event) => {
        console.log("clicked");
        event.preventDefault();
        var itemNum = $('.sku').text();
        var skuTitle = $('.skuTitle').val();
        var descript = 'Innovations | ' + skuTitle + ' | ' + itemNum;

        const activeDiv = document.querySelector('.owl-item.active .main-image-wrap') || document.querySelector('.main-image-wrap');
        var mediaUrl = activeDiv.querySelector('img').src;
        var shareUrl = window.location.href.replace('#', '');

        var url_1 = '', url_2 = '';

        if(param == 'pinterest') {
            url_2 = 'https://pinterest.com/pin/create/button/?url=';
        }else if(param == 'instagram') {
            url_2 = 'https://www.instagram.com/sharing_app/?u=';
        }else if(param == 'facebook') {
            url_2 = 'https://www.facebook.com/sharer/sharer.php?u=';
        }else if(param == 'linkedin') {
            url_2 = 'https://www.linkedin.com/sharing/share-offsite/?url=';
        }
        var shareTxt = '&description=' + encodeURIComponent(descript) + '&media=' + encodeURIComponent(mediaUrl);
        url_1 = url_2 + encodeURIComponent(shareUrl) + shareTxt;

        popitup(url_1, 600, 600);
        return false;
    }
    useEffect(() => {
        var projectTitle = $('.title').text();
        var shareUrl = window.location.href.replace('#', '');
        var url = 'mailto:?subject=Sharing' + projectTitle + '&amp;body=';
        url += encodeURIComponent('Innovations in Wallcovering posted this wallcovering project');
        url +='%0D%0A';
        
        var mailToUrl = url + encodeURIComponent(shareUrl);
        setMailTo(mailToUrl);
    }, [])
    
    const popitup = (url, ww, hh) => {

        var newwindow = window.open(url,'myPopup','width='+ ww +',height=' + hh);
        if (window.focus) {newwindow.focus()}
        
        return false;
    };
    
    const handleMouseOver = () => {
        setShow(true);
    }
    const handleMouseOut = () => {
        setTimeout(() => setShow(false), 3000);
    }

    return (
        <div className="wrapped-icon-group">
            <a href="#" onMouseOver={handleMouseOver}><img className='share-icon-main' src="/images/icons/share-icon1.svg" /></a>
            {
                show && 
                <div className='share-icons-group' id='share-icons-group' onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                    {/* <a href="#" className="instagram" onMouseOver={handleMouseOver} onClick={(event) => shareTo('instagram', event)}><img className='share-icon' src="/images/icons/share-instagram.svg" /></a> */}
                    <a href="#" className="pinterest" onMouseOver={handleMouseOver} onClick={(event) => shareTo('pinterest', event)}><img className='share-icon' src="/images/icons/share-pinterest.svg" /></a>
                    {/* <a href="#" className="facebook" onMouseOver={handleMouseOver} onClick={(event) => shareTo('facebook', event)}><img className='share-icon' src="/images/icons/share-facebook.svg" /></a> */}
                    <a href="#" className="linkedin" onMouseOver={handleMouseOver} onClick={(event) => shareTo('linkedin', event)}><img className='share-icon' src="/images/icons/share-linkedIn.svg" /></a>
                    <a href={mailto} className="email" onMouseOver={handleMouseOver}><img className='share-icon' src="/images/icons/share-email.svg" /></a>
                </div>
            }
        </div>
    );
}

if (document.getElementById("share-section")) {
ReactDOM.render(<ShareIcon />, document.getElementById('share-section'));
}
